import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';
import { MealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';

export { MealTypesEnum };

export const BODY_FONT_SIZE = 14;

const HOME = '/pointofsale';
const SERVING = `${HOME}/serving`;

export const POS_ROUTES = {
  HOME,
  SERVE_OPTIONS: `${HOME}/serveoptions`,
  SERVING,
  MEAL_COUNTER: `${SERVING}/cep`,
  QUEUE: `${SERVING}/individual`,
  QUEUE_NEW: `${SERVING}/individual/new`,
  QUEUE_INDIVIDUAL: `${SERVING}/individual/:id`,
  OTHER: `${SERVING}/other`,
  OTHER_INDIVIDUAL: `${SERVING}/other/:id`,
  GROUP: `${SERVING}/group`,
  GROUP_INDIVIDUAL: `${SERVING}/group/:id`,
  TEACHER: `${SERVING}/teacher`,
  TEACHER_INDIVIDUAL: `${SERVING}/teacher/:id`,
};

export const ITEMS_PER_ROW = 4;

export const AUTO_SERVE_OPTIONS = {
  MealCounter: 1,
  StudentSpecific: 2,
};

export const QueuedDirectionEnum = {
  None: 0,
  Left: 1,
  Right: 2,
};

export const SymbolIndicatorEnum = {
  ServingDirection: 'ServingDirection',
  ManuallyKeyed: 'ManuallyKeyed',
  SpecialMessage: 'SpecialMessage',
  Allergen: 'Allergen',
  InvalidStudent: 'InvalidStudent',
  VisitingStudent: 'VisitingStudent',
};

export const INVALID_STUDENT = {
  FullName: 'INVALID STUDENT',
  FirstName: 'INVALID',
  LastName: 'STUDENT',
  Id: '0',
  IdSeed: 0,
  PrimarySiteId: '',
  ServingNumber: '',
};

export const MEAL_TYPES = [
  { label: 'Breakfast', selected: false, key: 'breakFast' },
  { label: 'Lunch', selected: false, key: 'lunch' },
  { label: 'Supper', selected: false, key: 'supper' },
  { label: 'Other', selected: false, key: 'other' },
];

const mealTypeLabels = {};
MEAL_TYPES.forEach(mt => {
  mealTypeLabels[mt.label] = mt.label;
});

export const MEAL_TYPES_LABELS = mealTypeLabels;

export const QueueStatusEnum = {
  ON: 'ON',
  OFF: 'OFF',
  PAUSED: 'PAUSED',
};

export const SessionTypes = {
  Queue: 'Queue',
  Group: 'Group',
  Teacher: 'Teacher',
};

export const SessionTypeDetails = {
  [SessionTypes.Queue]: { label: 'Individual' },
  [SessionTypes.Group]: { label: 'Group' },
  [SessionTypes.Teacher]: { label: 'Teacher' },
};

export const MENU_ITEMS = [
  {
    key: SessionTypes.Queue,
    description: SessionTypeDetails[SessionTypes.Queue].label,
    selected: false,
  },
  {
    key: SessionTypes.Teacher,
    description: SessionTypeDetails[SessionTypes.Teacher].label,
    selected: false,
  },
  {
    key: SessionTypes.Group,
    description: SessionTypeDetails[SessionTypes.Group].label,
    selected: false,
  },
];

export const ProhibitedItemFlags = {
  Free: '2',
  Reduced: '3',
  Paid: '4',
  Student: '5',
  Teacher: '6',
  Adult: '7',
  SFS: '8',
  Catered: '9',
};

export const StatusPriceMap = {
  [StatusEnum.Deleted]: 'StudentPrice',
  [StatusEnum.Free]: 'FreePrice',
  [StatusEnum.Reduced]: 'ReducedPrice',
  [StatusEnum.Paid]: 'StudentPrice',
  [StatusEnum.Withdrawn]: 'StudentPrice',
  [StatusEnum.Teacher]: 'TeacherPrice',
  [StatusEnum.Adult]: 'AdultPrice',
  [StatusEnum.SchoolFoodService]: 'SFSPrice',
  [StatusEnum.Catering]: 'CateredPrice',
};

export const SUB_MENU = {
  [SessionTypes.Queue]: [
    { Id: 1, Description: 'Auto Serve', selected: false },
    { Id: 2, Description: 'Quick Serve Items', selected: false },
  ],
  [SessionTypes.Group]: [
    { Id: 1, Description: 'Auto Serve', selected: false, disabled: true },
    { Id: 2, Description: 'Quick Serve Items', selected: false },
  ],
  [SessionTypes.Teacher]: [
    { Id: 1, Description: 'Auto Serve', selected: false, disabled: true },
    { Id: 2, Description: 'Quick Serve Items', selected: false },
  ],
};

export const KEYPAD_KEYS = {
  LEFT: '[',
  RIGHT: ']',
};

export const statusToClassMap = {
  [StatusEnum.Free]: 'bd-orange',
  [StatusEnum.Reduced]: 'bd-green',
};

// Only show search results for 2,3,4,5,6,7,8,9
export const SearchStatuses = [
  StatusEnum.Free,
  StatusEnum.Reduced,
  StatusEnum.Paid,
  StatusEnum.Withdrawn,
  StatusEnum.Teacher,
  StatusEnum.Adult,
  StatusEnum.SchoolFoodService,
  StatusEnum.Catering,
];



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/constants/index.js